import styled from 'styled-components';

export const BonusInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;
